<template>
    <div v-if="mission" class="small">
        <h6 class="mb-2 d-flex align-items-center gap-2">
            Véhicule principal
        </h6>
        <div v-if="isEdit" class="position-relative" style="min-width: 280px;">
            <BaliseSelect :selectedBaliseId="mission.transporteurId" dropdownMode="fixed" class="w-100"
                @baliseChange="onBaliseChange" />
        </div>
        <div v-else class="d-flex flex-wrap align-items-center gap-2">
            <template v-if="mission.transporteur">
                <!-- Look “capsule” comme la liste compacte -->
                <VehicleNameDisplay :balise="mission.transporteur"
                    class="bg-success bg-opacity-10 rounded px-2 py-1 my-1" />
            </template>
            <template v-else>
                <span class="text-muted">Aucun véhicule principal</span>
            </template>
        </div>
    </div>
</template>

<script>
import BaliseSelect from '@/components/display/BaliseSelect.vue'
import VehicleNameDisplay from '@/components/display/VehicleNameDisplay.vue'

export default {
    name: 'MissionTransporteurCard',
    props: {
        mission: { type: Object, required: true },
        /**
         * uiMode:
         *  - 'auto' (défaut) : édition si (PENDING|DRAFT) && !viewer
         *  - 'view' : force la lecture seule (aucune édition)
         *  - 'edit' : force l'édition (optionnel, utile en tests)
         */
        uiMode: {
            type: String,
            default: 'auto',
            validator: v => ['auto', 'view', 'edit'].includes(v)
        }
    },
    components: { BaliseSelect, VehicleNameDisplay },
    computed: {
        isEdit() {
            if (this.uiMode === 'edit') return true;
            if (this.uiMode === 'view') return false;
            // auto
            return (this.mission?.status === 'PENDING' || this.mission?.status === 'DRAFT') && !this.$isViewer;
        },
        hasTransporteur() {
            return !!(
                this.mission?.transporteurId ||
                this.mission?.transporteur?.id
            );
        },
    },
    methods: {
        onBaliseChange(balise) {
            // on remonte l'objet balise pour rester compatible avec MissionPanel.transporteurUpdate(balise)
            this.$emit('transporteurUpdate', balise);
        }
    }
}
</script>
